module.exports = __webpack_public_path__ + "img/wallet-black.c795aa79.svg";